<template>
	<div class="contentContainer">
		<div class="content">
			<br>
			<h1>Отримати станцію</h1>
			<br>

			<div class="bg-gray-950 p-5 rounded-xl -mx-[1em]">

				<h2>
					Готові комплектації
				</h2>
				<div class="flex flex-row gap-3 overflow-x-auto rounded pb-2">
					<button 
						v-for="preset in presets"
						:key="preset.name"
						class="px-4 py-3 flex gap-3 max-w-[260px] min-w-[200px] text-left bg-gray-900 hover:bg-gray-800 rounded-md outline-none transition-all duration-200 border border-gray-800"
					>
						<!-- <div class="shrink-0 mt-5">
							<FontAwesomeIcon :icon="preset.icon" class="text-2xl px-1" />
						</div> -->
						<div class="flex flex-col gap-2">
							<div class="f text-xl font-black">
								{{ preset.name }}
							</div>
							<div>
								{{ preset.description }}
							</div>
							<div class="flex flex-row gap-1 flex-wrap">
								<div 
									v-for="sensor in preset.sensors"
									:key="sensor"
									class="text-xs font-semibold px-1.5 py-0.5 bg-gray-700 rounded-xl"
								>
									{{ sensor}}
								</div>
							</div>
						</div>
					</button>
				</div>

				<h2>
					Конфігуратор
				</h2>
				<div class="border border-gray-800 p-4 rounded-md grow overflow-hidden box-border">
					<div class="text-md font-bold mb-2">
						Станція
					</div>
					<div class="flex flex-row flex-wrap gap-2 overflow-x-auto rounded max-w-full pb-4">
						<button 
							v-for="s in stations"
							:key="s.name"
							class="pl-4 pr-5 py-3 flex items-center gap-3 text-left rounded-md outline-none transition-all duration-200 border border-gray-800"
							@click="selectedStation = s.name"
							:class="{
								'bg-gray-100': selectedStation == s.name,
								'text-gray-900': selectedStation == s.name,
								'bg-gray-900': selectedStation != s.name,
								'hover:bg-gray-800': selectedStation != s.name,
							}"
						>
							<div>
								<FontAwesomeIcon :icon="s.icon" class="text-md" />
							</div>
							<div class="flex flex-col gap-0.5">
								<div>
									{{ s.name }}
								</div>
								<div class="text-xs font-semibold">
									{{ s.description }}
								</div>
							</div>
						</button>
					</div>

					<div>
						<div v-for="c in categories" :key="c.name" class="mb-4">
							<div class="text-md font-bold mb-1">
								{{ c.name }}
							</div>
							<div class="text-xs mb-2">
								{{ c.description }}
							</div>
							<div class="flex flex-row gap-2 rounded overflow-x-auto pb-1">
								<button 
									v-for="s in c.sensors"
									:key="s.name"
									class="min-w-[200px] max-w-[240px] px-3 py-2 flex items-center gap-3 text-left rounded-md outline-none transition-all duration-200 border border-gray-800"
									@click="toggleSensor(s.name)"
									:class="{
										'bg-gray-100': selectedSensors.includes(s.name),
										'text-gray-900': selectedSensors.includes(s.name),
										'bg-gray-900': !selectedSensors.includes(s.name),
										'hover:bg-gray-800': !selectedSensors.includes(s.name),
									}"
								>
									<div>
										<img 
											v-if="s.icon"
											:src="s.icon" 
											:alt="'image of ' + s.name" 
											class="w-10 h-10 object-contain rounded" 
										/>
									</div>
									<div class="flex flex-col gap-0.5">
										<div class="font-semibold">
											{{ s.name }}
										</div>
										<div class="text-xs">
											{{ s.description }}
										</div>
									</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>


			<!-- <img src="https://eco-city.org.ua/uploads/75322044616979-21-400x225.jpg" alt="station" style="width: 100%; max-width: 400px; margin: auto; display: block; border-radius: 0.5em;"/>
			<br>
			<p>
				Отримати станцію моніторингу від програми "Чисте повітря для України" можна за посиланням
			</p>
			<p>
				<a href="https://cleanair.org.ua/vstanovy-sviy-sensor/">
					Заповніть форму та очікуйте відповідь на пошту.
				</a>
			</p>

			<br>

			<p>
				Також можна придбати станції безпосередньо у магазині BeeGreen за посиланням
			</p>
			<p>
				<a href="https://beegreen.com.ua/monitoryng-yakosti-povitrya/">
					Замовте станцію та отримайте її до 10 днів.
				</a>
			</p>

			<br>
			<br>
			<br> -->


		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

const presets = [
	{
		name: 'База',
		description: 'Просто і доступно!',
		icon: faCircleCheck,
		sensors: [ 'PM2.5', 'PM10' ],
	},
	{
		name: 'Атом',
		description: 'Постійний моніторинг радіації. Підійде якщо поряд АЕС.',
		icon: faCircleCheck,
		sensors: [ 'PM2.5', 'PM10', 'Радіація' ],
	},
	{
		name: 'Місто',
		description: 'Для міста з великою кількістю автомобілів.',
		icon: faCircleCheck,
		sensors: [ 'PM2.5', 'PM10', 'Радіація', 'NO2', 'CO', 'NH3' ],
	},
	{
		name: 'Органіка',
		description: 'Для регіонів з можливим органічним забрудненням.',
		icon: faCircleCheck,
		sensors: [ 'PM2.5', 'PM10', 'NH3', 'CO', 'Електронний ніс' ],
	},
]

const stations = [
	{
		name: "AirFresh Max",
		icon: faCircleCheck,
		description: "Просунута"
	},
	{
		name: "AirFresh",
		icon: faCircleCheck,
		description: "Бюджетна"
	},
	{
		name: "AirHome",
		icon: faCircleCheck,
		description: "Для дому"
	},
]

const selectedStation = ref(stations[0].name)

const sensors = [
	{
		name: "SDS011",
		icon: "https://aqicn.org/air/images/sensors/sds011-large.png",
		pollutants: ["PM2.5", "PM10"],
		description: "Лазерний сенсор",
	},
	{
		name: "PMS7003",
		icon: "https://thejimster82.github.io/CvilleAQ/assets/img/sensors/pms7003.png",
		pollutants: ["PM1", "PM2.5", "PM10"],
		description: "Компактний лазерний сенсор",
	},
	{
		name: "MH-Z19",
		icon: "https://home-assistant-china.github.io/images/supported_brands/mhz19_logo.png",
		pollutants: ["CO2"],
		description: "Лазерний сенсор",
	},
	{
		name: "MiCS-6814",
		icon: "https://sensorsandpower.angst-pfister.com/fileadmin/_processed_/d/8/csm_103-25-394-001-BL-0615_01_66f2d6bbbe.png",
		pollutants: ["NO2", "CO", "NH3"],
		description: "Бюджетний металоксидний мульти-сенсор",
		is_multisensor: true,
	},
	{
		name: "ZE07-CO",
		icon: "https://gw.alicdn.com/imgextra/i4/2201475205739/O1CN01KuSyJE1sGVzG53PIt_!!2-item_pic.png_.webp",
		pollutants: ["CO"],
		description: "Бюджетний електрохімічний сенсор",
	},
	{
		name: "ZE07-CH20",
		icon: "https://gw.alicdn.com/imgextra/i4/2201475205739/O1CN01KuSyJE1sGVzG53PIt_!!2-item_pic.png_.webp",
		pollutants: ["CH2O"],
		description: "Бюджетний електрохімічний сенсор",
	},
	{
		name: "ZE08-CH20",
		icon: "https://www.newpecas.com.br/produto/imagem/sensor-de-gas-ze08-ch2o-formaldeido.webp",
		pollutants: ["CH2O"],
		description: "Бюджетний електрохімічний сенсор",
	},
	{
		name: "ZE27-O3",
		icon: "/sensors/ze27-o3.avif",
		pollutants: ["O3"],
		description: "Бюджетний електрохімічний сенсор",
	},
	{
		name: "RadKit",
		icon: "https://ae04.alicdn.com/kf/S9be0fa79761b49aa8080981cdc458d660.png",
		pollutants: ["Радіаційний фон"],
		description: "Дозиметр власного виробництва",
	},
	{
		name: "ZPHS01B",
		icon: "/sensors/zphs01b.png",
		pollutants: ["PM2.5", "PM10", "CO2", "NO2", "CO", "O3", "TVOC"],
		description: "Багатофункціональний модуль",
		is_multisensor: true,
	},
	{
		name: "ZE03-DG",
		icon: "https://gw.alicdn.com/imgextra/i2/2201475205739/O1CN010XqIOC1sGW0dy4PMC_!!2-item_pic.png_.webp",
		pollutants: ["DG"],
		description: "Сенсор одорації",
	},
]

; [ "CO", "NO2", "H2S", "SO2", "O3" ].forEach(p => {
	sensors.push({
		name: "ZE12-" + p,
		icon: "/sensors/ze12a.png",
		pollutants: [p],
		description: "Професійний електрохімічний сенсор",
	})
})

; [ "CO", "SO2", "H2S", "O2", "O3", "NH3", "NO2", "CL2" ].forEach(p => {
	sensors.push({
		name: "ZE03-" + p,
		icon: "https://gw.alicdn.com/imgextra/i2/2201475205739/O1CN010XqIOC1sGW0dy4PMC_!!2-item_pic.png_.webp",
		pollutants: [p],
		description: "Сенсор для робочої зони",
	})
})

const categories = [
	{
		name: "Мікропил",
		description: "Мікропил це частинки розміром менше 10 мкм, які можуть потрапляти в легені та викликати проблеми з диханням.",
		sensors: sensors.filter(s => s.pollutants.includes("PM2.5")),
	},
	{
		name: "Чадний газ",
		description: "Безбарвний газ, який може викликати проблеми з диханням та серцево-судинною системою.",
		sensors: sensors.filter(s => s.pollutants.includes("CO")),
	},
	{
		name: "Діоксид азоту",
		description: "Зазвичай виникає внаслідок спалювання пального, і може викликати проблеми з диханням та серцево-судинною системою.",
		sensors: sensors.filter(s => s.pollutants.includes("NO2")),
	},
	{
		name: "Аміак",
		description: "Газ, який може викликати проблеми з диханням та подразнення слизових оболонок.",
		sensors: sensors.filter(s => s.pollutants.includes("NH3")),
	},
	{
		name: "Вуглекислий газ",
		description: "Парниковий газ, що впливає на глобальне потепління.",
		sensors: sensors.filter(s => s.pollutants.includes("CO2")),
	},
	{
		name: "Формальдегід",
		description: "Органічний забруднювач, який може викликати проблеми з диханням та подразнення слизових оболонок.",
		sensors: sensors.filter(s => s.pollutants.includes("CH2O")),
	},
	{
		name: "Озон",
		description: "Шкідливий газ, що викликає серцево-судинні захворювання.",
		sensors: sensors.filter(s => s.pollutants.includes("O3")),
	},
	{
		name: "Інші",
		description: "Інші забруднювачі, які можуть бути присутніми в повітрі.",
		sensors: [],
	}
]

categories.find(c => c.name == "Інші").sensors = sensors.filter(s => !categories.some(c => c.sensors.includes(s)))

const selectedSensors = ref([])

function toggleSensor(sensor) {
	if (selectedSensors.value.includes(sensor)) {
		selectedSensors.value = selectedSensors.value.filter(s => s != sensor)
	} else {
		// Remove sensors from same category
		categories.forEach(c => {
			if (c.sensors.some(s => s.name == sensor)) {
				selectedSensors.value = selectedSensors.value.filter(s => !c.sensors.some(cs => cs.name == s))
			}
		})

		// Add sensor
		selectedSensors.value.push(sensor)
	}

	// Add default sensor
	if (selectedSensors.value.some(s => sensors.find(ss => ss.name == s).pollutants.includes("PM2.5")) == false) {
		selectedSensors.value.push(sensors[0].name)
	}
}
</script>

<style scoped>

</style>